import AxiosInstance from "./api";

export const ContractLiquidationAcceptanceMinutesService = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/contract-liquidation-acceptance-minutes", { params: query });
  },
  getById: async (id) => {
    return await AxiosInstance.get(`/private/contract-liquidation-acceptance-minutes/${id}`);
  },
  create: async (payload) => {
    return await AxiosInstance.post("/private/contract-liquidation-acceptance-minutes", payload);
  },
  update: async (id, payload) => {
    return await AxiosInstance.patch(`/private/contract-liquidation-acceptance-minutes/${id}`, payload);
  },
  delete: async (id) => {
    return await AxiosInstance.delete(`/private/contract-liquidation-acceptance-minutes/${id}`);
  },
};
